import tw from 'twin.macro';
import styled from 'styled-components';

// Wrapper for the entire section
export const Wrapper = tw.div`
  relative w-full h-screen mt-0 overflow-hidden flex items-center
`;

// Background image styling
export const BackgroundImage = styled.img`
  ${tw`absolute top-0 left-0 w-full h-full object-cover filter`}
  filter: grayscale(50%);
`;

// Content overlay styling
export const ContentOverlay = tw.div`
  relative z-10 text-white text-center w-4/5 sm:w-1/2 p-2 sm:p-5 flex flex-col justify-center items-center mx-auto my-auto
`;

// Heading styling
export const Heading = tw.h1`
  text-4xl  mb-5 border-b py-2
`;

// Paragraph styling
export const Paragraph = tw.p`
  text-center text-lg
`;

// Contact button styling
export const ContactButton = styled.a`
  ${tw`border border-white text-white no-underline py-3 px-4 mt-4 uppercase font-semibold transition duration-300 ease-in-out`}
  &:hover {
    ${tw`bg-white text-black`}
  }
`;

// Modal Header Title styling
export const ModalHeaderTitle = tw.h1`
  ms-5 text-2xl font-bold
`;
